import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppMainComponent } from '../app.main.component';
import { ConfigurationService } from '../services/config.service';
import { MenuSection } from './app.menu.service';

@Component({
	selector: 'app-menu',
	templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
	model: MenuSection[];

	constructor(
		public app: AppMainComponent,
		private translate: TranslateService,
		private configurationService: ConfigurationService,
	) {}

	ngOnInit() {
		this.model = [
			{
				label: 'menu.administration',
				icon: 'pi pi-database',
				items: [
					{
						label: 'menu.administration.utilisateurs',
						icon: 'pi pi-user',
						routerLink: ['/inventaire/utilisateur'],
						disabled: false,
					},
					{
						label: 'menu.administration.exploitations',
						icon: 'pi pi-building',
						routerLink: ['/inventaire/exploitation'],
						disabled: false,
					},
					{
						label: 'menu.administration.messages',
						icon: 'pi pi-comment',
						routerLink: ['/messages'],
						disabled: false,
					},
					{
						label: 'menu.administration.versions',
						icon: 'pi pi-tags',
						routerLink: ['/version'],
						disabled: false,
					},
				],
			},
		];
	}
}
